import { create } from 'zustand'

interface SignInSignUpStore {
  // Modal state
  isModalOpen: boolean
  toggleModal: () => void
  
  // Tab state
  activeTab: 'signIn' | 'register'
  setActiveTab: (tab: 'signIn' | 'register') => void
  
  // Sign In form state
  usePhone: boolean
  emailOrPhone: string
  password: string
  showPassword: boolean
  setUsePhone: (value: boolean) => void
  setEmailOrPhone: (value: string) => void
  setPassword: (value: string) => void
  setShowPassword: (value: boolean) => void
  
  // Register form state
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  address: string
  dateOfBirth: Date | null
  confirmPassword: string
  acceptTerms: boolean
  setFirstName: (value: string) => void
  setLastName: (value: string) => void
  setEmail: (value: string) => void
  setPhoneNumber: (value: string) => void
  setAddress: (value: string) => void
  setDateOfBirth: (value: Date | null) => void
  setConfirmPassword: (value: string) => void
  setAcceptTerms: (value: boolean) => void
  
  // Form reset
  resetForms: () => void
}

export const useSignInSignUpStore = create<SignInSignUpStore>((set) => ({
  // Modal state
  isModalOpen: false,
  toggleModal: () => set((state) => ({ isModalOpen: !state.isModalOpen })),
  
  // Tab state
  activeTab: 'signIn',
  setActiveTab: (tab) => set({ activeTab: tab }),
  
  // Sign In form state
  usePhone: false,
  emailOrPhone: '',
  password: '',
  showPassword: false,
  setUsePhone: (value) => set({ usePhone: value }),
  setEmailOrPhone: (value) => set({ emailOrPhone: value }),
  setPassword: (value) => set({ password: value }),
  setShowPassword: (value) => set({ showPassword: value }),
  
  // Register form state
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  address: '',
  dateOfBirth: null,
  confirmPassword: '',
  acceptTerms: false,
  setFirstName: (value) => set({ firstName: value }),
  setLastName: (value) => set({ lastName: value }),
  setEmail: (value) => set({ email: value }),
  setPhoneNumber: (value) => set({ phoneNumber: value }),
  setAddress: (value) => set({ address: value }),
  setDateOfBirth: (value) => set({ dateOfBirth: value }),
  setConfirmPassword: (value) => set({ confirmPassword: value }),
  setAcceptTerms: (value) => set({ acceptTerms: value }),
  
  // Form reset
  resetForms: () => set({
    usePhone: false,
    emailOrPhone: '',
    password: '',
    showPassword: false,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    address: '',
    dateOfBirth: null,
    confirmPassword: '',
    acceptTerms: false,
    activeTab: 'signIn'
  })
}))

interface PasswordRecoveryStore {
  usePhone: boolean
  isModalOpen: boolean
  inputValue: string
  setUsePhone: (value: boolean) => void
  setIsModalOpen: (value: boolean) => void
  setInputValue: (value: string) => void
  toggleModal: () => void
  resetForm: () => void
}

export const usePasswordRecoveryStore = create<PasswordRecoveryStore>((set) => ({
  usePhone: false,
  isModalOpen: false,
  inputValue: '',
  setUsePhone: (value) => set({ usePhone: value }),
  setIsModalOpen: (value) => set({ isModalOpen: value }),
  setInputValue: (value) => set({ inputValue: value }),
  toggleModal: () => set((state) => ({ isModalOpen: !state.isModalOpen })),
  resetForm: () => set({ usePhone: false, inputValue: '', isModalOpen: false })
}))